import { NotificationCampaignStatus } from "../../../../redux/type";

const STATUS_STYLES: Record<
  NotificationCampaignStatus,
  { bg: string; text: string; label: string }
> = {
  draft: { bg: "bg-[#F4F4F5]", text: "text-[#71717A]", label: "Draft" },
  scheduled: { bg: "bg-[#FEF9C3]", text: "text-[#CA8A04]", label: "Scheduled" },
  active: { bg: "bg-[#EFF6FF]", text: "text-[#2563EB]", label: "Active" },
  sent: { bg: "bg-[#ECFDF3]", text: "text-[#16A34A]", label: "Sent" },
  failed: { bg: "bg-[#FEF2F2]", text: "text-[#DC2626]", label: "Failed" },
  cancelled: { bg: "bg-[#F4F4F5]", text: "text-[#71717A]", label: "Cancelled" },
};

interface NotificationStatusBadgeProps {
  status: NotificationCampaignStatus;
}

export default function NotificationStatusBadge({ status }: NotificationStatusBadgeProps) {
  const styles = STATUS_STYLES[status];

  return (
    <span
      className={`inline-flex items-center rounded-full px-[10px] py-[4px] text-[12px] font-medium ${styles.bg} ${styles.text}`}
    >
      {styles.label}
    </span>
  );
}
